import { render, staticRenderFns } from "./rm1000.vue?vue&type=template&id=4b6c396d&scoped=true"
import script from "./rm1000.vue?vue&type=script&lang=js"
export * from "./rm1000.vue?vue&type=script&lang=js"
import style0 from "./rm1000.vue?vue&type=style&index=0&id=4b6c396d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6c396d",
  null
  
)

export default component.exports